import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { EnumsService, PhonebooksService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import {
  GetCustomerClubDeviceByIdDto,
  GetEnumValuesDto,
} from '../../../../core/api/models';
import { TranslationService } from '../../../../i18n/translation.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';

@Component({
    selector: 'app-customer-club-devices-details',
    templateUrl: './customer-club-devices-details.component.html',
    imports: [BaseIndexModule, SmsBodyModule, ReactiveFormsModule]
})
export class CustomerClubDevicesDetailsComponent implements OnInit {
  //#region Properties

  fields = 'pages.customerClubDevice.form.fields.';
  title = 'pages.customerClubDevice.form.detailTitle';

  @Input() model: GetCustomerClubDeviceByIdDto;
  @Input() organizationId: number;
  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  DelayTypeEnumValues: GetEnumValuesDto[] = [];
  phoneBookFilterList: any[] = [];
  filteredItems: any[] = [];

  protected onDestroy$ = new Subject<void>();

  //#endregion

  constructor(
    private phonebooksService: PhonebooksService,
    public translationService: TranslationService,
    protected enumService: EnumsService,
    protected loggerService: LoggerService
  ) {}

  ngOnInit() {
    try {
      this.getEnumsValues();
      this.getPhonebooksServiceApi();
    } catch (error) {
      this.loggerService.logError(
        'app-customer-club-devices-details',
        error,
        EventTypes.facility
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsSentPeriodType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DelayTypeEnumValues = values));
  }

  //#region api

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    try {
      return this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(
          takeUntil(this.onDestroy$),
          map((res) => res.data)
        );
    } catch (error) {
      this.loggerService.logError(
        'app-customer-club-devices-details',
        error,
        EventTypes.facility
      );
    }
  }

  getPhonebooksServiceApi() {
    this.phonebooksService
      .phonebooksGetPhonebooksForDevicesByOrganizationId({
        OrganizationId: this.organizationId,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((items) => {
        items.data?.forEach((el) => {
          if (this.model.phonebookIdList.some((id) => id == el.id)) {
            this.filteredItems.push(el);
          }
        });
        this.phoneBookFilterList = this.filteredItems;
      });
  }

  //#endregion

  onClose() {
    this.output_closPage.emit(true);
  }
}
